import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Works,
  Link,
  LinkIcon,
  GetStartedInput,
  AboutBanner,
  AutocompleteSearch,
  AykCtaPanel,
} from '../../components'

const Styles = require('./Home.css')

@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  constructor() {
    super()
    this.state = {}
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    // const link = config.domain
    // const message = config.shareMessage
    const iconTrnsprntMmc = require( '../../../static/images/icn-mmc-inactive-slash-transparent.svg' )
    const iconTrnsprntNw = require( '../../../static/images/icn-nw-inactive-slash-transparent.svg' )
    const iconTrnsprntCm = require( '../../../static/images/icn-cm-inactive-slash-transparent.svg' )
    const iconMmc = require( '../../../static/images/icn-mmc-active-black.svg' )
    const iconNw = require( '../../../static/images/icn-nw-active-black.svg' )
    const iconCm = require( '../../../static/images/icn-cm-active-black.svg' )
    const iconGff = require( '../../../static/images/icons/gff-icn-clr.png' )
    const iconFunds = require( '../../../static/images/home-icons/funds-2-white.png' )
    const iconManagers = require( '../../../static/images/home-icons/managers-white.png' )
    const iconAction = require( '../../../static/images/home-icons/plans-white.png' )
    const dfwLogo = require( '../../../static/images/dfw.svg' )

    //
    return (
      <div>
        { 
          container.helmet(
            config.app.title,
            config.app.description,
            config.domain
          )
        }

        { /*
          PAGE HEADER PANEL
        */ }
        <section styleName='banner-wrapper'>
          <ContainerDivs>
            <div styleName='banner-inner'>
              <h1 styleName='banner-title'>
                We have the power to cut our financial ties
                to <span styleName='red'>militarism</span>
              </h1>
              <div styleName='banner-icons'>
                <img
                  styleName='banner-icon'
                  src={iconTrnsprntMmc}
                  role='presentation'
                />
                <img
                  styleName='banner-icon'
                  src={iconTrnsprntNw}
                  role='presentation'
                />
                <img
                  styleName='banner-icon'
                  src={iconTrnsprntCm}
                  role='presentation'
                />
              </div>

              <div styleName='banner-form-wrap'>
                <h2 styleName='banner-tagline'>
                  Search for mutual funds & ETFs from your 401(k), IRA, or
                  personal portfolio
                </h2>
                <div styleName='banner-input-wrap-outer'>
                  <div styleName='banner-input-wrap-inner'>
                    <AutocompleteSearch />
                  </div>
                </div>


                <div styleName='banner-btn-wrap'>
                  <h2 styleName='banner-tagline-2'>
                    Find sustainable funds that avoid weapon investments
                  </h2>
                  <div>
                    <Link
                      to={config.routes.clean}
                      whitebutton
                      title='Get started'
                    >
                        Top-scoring funds<LinkIcon />
                    </Link>
                  </div>
                </div>

              </div>

            </div>
          </ContainerDivs>
        </section>

        <AykCtaPanel />

        { /*
        <section styleName='home-123-wrap'>
          <ContainerDivs>
            <Row>
              { [[iconFunds,
                  'Mutual Funds',
                  (<span>
                    Search our database of thousands of mutual funds
                    to find sustainable, weapon-free portfolios.
                   </span>),
                  config.routes.clean,
                  'Search funds'],
                 [iconManagers,
                  'Fund Managers',
                  (<span>
                    See how the largest fund managers compare to sustainable
                    firms. We've rated hundreds of fund companies.
                   </span>),
                  config.routes.fundManagers,
                  'Search fund managers'],
                 [iconAction,
                  'Retirement Plans',
                  (<span>
                    We've analyzed the 401(k)s of 55 major employers and found
                    billions in arms investments.
                   </span>),
                  config.routes.retirementPlans,
                  'Action toolkit']].map((e, i) => {
                    return <Col
                      key={'home-123-'+i}
                      xs={12} sm={12} md={4}
                      styleName='home-123-cell'
                    >
                      <div styleName='home-123-cell-inner'>
                        <Link
                          to={e[3]}
                          title={e[4]}
                        >
                          <div styleName='home-123-img-wrap'>
                            <img
                              src={e[0]}
                              alt={e[1]}
                            />
                          </div>
                        </Link>
                        <h3 styleName='home-123-label'>
                          {e[1]}
                        </h3>
                        <p styleName='home-123-info'>
                          {e[2]}
                        </p>
                        <p styleName='home-123-link'>
                          <Link
                            to={e[3]}
                            title={e[4]}
                          >
                            <span styleName='home-123-link-span'>
                              {e[4]}<LinkIcon />
                            </span>
                          </Link>
                        </p>
                      </div>
                    </Col>
                  })
              }
            </Row>
          </ContainerDivs>
        </section>
        */ }


        { /*
          INTRO CONTENT PANEL
        */ }
        <section styleName='intro-content'>
          <ContainerDivs>
            <h2 styleName='intro-content-title'>
              Make a change and invest in a <span styleName='pink'>peaceful future</span>
            </h2>
            <div styleName='intro-content-bullets-wrap'>
              <p>
                Investing in companies involved in
                producing military weapons is
                a <b styleName='red'>risky business</b>.
                Concerns about social impact, human rights,
                reputation risk, and regulatory risks
                are just a few of the reasons
                weapon free investing has been a
                common component of sustainable investing for decades.
              </p>
              <p>
                Despite global calls for restraint and nuclear disarmament,
                new <b styleName='red'>nuclear weapons</b> are being developed in all nuclear armed
                countries, with investor-owned companies involved in
                constructing, maintaining, and stockpiling nuclear weapons.
                Some arms producers also manufacture <b styleName='red'>internationally-banned
                weapons</b> like cluster
                munitions, anti-personnel
                landmines, incendiary
                weapons, and depleted
                uranium.
              </p>
              <p>
                Use our database to find out if your 401(k), mutual funds, or
                exchange-traded funds are invested in:
              </p>
              <ul>
                <li styleName='intro-content-bullet'>
                  <img
                    styleName='intro-content-bullet-icon'
                    src={iconMmc}
                    alt='Major military contractors'
                  />
                  <span>
                    The largest publicly-traded <strong>arms
                    manufacturers</strong> and <strong>military
                    contractors</strong>
                  </span>
                </li>
                <li styleName='intro-content-bullet'>
                  <img
                    styleName='intro-content-bullet-icon'
                    src={iconNw}
                    alt='Nuclear weapons'
                  />
                  <span>
                    Companies involved in the construction or maintenance
                    of <strong>nuclear weapons</strong>
                  </span>
                </li>
                <li styleName='intro-content-bullet'>
                  <img
                    styleName='intro-content-bullet-icon'
                    src={iconCm}
                    alt='Controversial weapons'
                  />
                  <span>
                    Companies involved
                    with <strong>controversial weapons</strong>,
                    including cluster munitions, anti-personnel landmines,
                    incendiary weapons, and depleted uranium
                  </span>
                </li>
              </ul>
              <h2 styleName='intro-content-subtitle'>
                Civilian firearms
              </h2>
              <p>
                We also track investments in civilian firearm manufacturers and
                retailers raking in billions in handgun, assault rifle, and
                ammunition sales. <b>Gun Free Funds</b> is made for people
                looking to align their investments with their values by
                moving money out of companies that make and sell guns.
              </p>
              <ul>
                <li styleName='intro-content-bullet'>
                  <Link
                    to={config.links.gff}
                    title='Gun Free Funds'
                  >
                    <img
                      src={iconGff}
                      styleName='intro-content-bullet-icon'
                      alt='Gun Free Funds'
                    />
                  </Link>
                  <span>
                    <Link to={config.links.gff} xstrong>
                      Visit Gun Free Funds<LinkIcon />
                    </Link>
                  </span>
                </li>
              </ul>
            </div>
          </ContainerDivs>
        </section>

        { /*
          HOW IT WORKS PANEL
        */ }
        <Works/>

        { /*
          DIVEST FROM WAR MACHINE PANEL
        */ }
        <section>
          <ContainerDivs>
            <div styleName='dfwm-banner'>
              <img
                src={dfwLogo}
                styleName='dfwm-logo'
                alt='Divest from the War Machine'
              />
              <div styleName='dfwm-title'>
                Reel in the U.S. war machine
              </div>
              <div styleName='dfwm-lede'>
                Take action to reduce violent global conflicts and slow the
                hyper-militarization of our world
              </div>
              <Link
                to={config.links.dfw}
                title='Learn more'
                bigbutton
              >
                Learn more<LinkIcon />
              </Link>
            </div>
          </ContainerDivs>
        </section>

        { /*
          GET STARTED PANEL
        */ }
        <GetStartedInput />

        { /*
          TO ABOUT PAGE PANEL
        */ }
        <ContainerDivs>
          <AboutBanner />
        </ContainerDivs>

      </div>
    )
  }
}

